import { gql } from "@apollo/client";

export const UPDATE_WELLNESS_MODAL = gql`
  query updateWellnessModalStatus {
    updateWellnessModalStatus {
      success
      messages
    }
  }
`;
